// extracted by mini-css-extract-plugin
export default {"category":"BrandProducts_category__xMvkX","rating":"BrandProducts_rating__Eu0go","item":"BrandProducts_item__LOxMY","addBtn":"BrandProducts_addBtn__1f5QX"};